<template>
  <labeled-status-badge
    label="Compliance"
    :value="label"
    :variant="variant"
    :class="`compliance-status-badge--${normalizedStatus}`"
  />
</template>

<script>
import LabeledStatusBadge from './LabeledStatusBadge.vue'

// D1: `compliance_status` on OTW candidates is one of
// none | non_compliant | action_required | verified — NOT a numeric 0-100
// score (an earlier design doc's `compliance_score: 98` shape was wrong).
const STATUS = {
  verified: { label: 'Verified', variant: 'success' },
  action_required: { label: 'Action Required', variant: 'warning' },
  non_compliant: { label: 'Non-Compliant', variant: 'danger' },
  none: { label: 'No Data', variant: 'secondary' },
}

export default {
  name: 'ComplianceStatusBadge',

  components: {
    LabeledStatusBadge,
  },

  props: {
    status: {
      type: String,
      default: 'none',
    },
  },

  computed: {
    normalizedStatus() {
      const s = (this.status || '').toLowerCase()
      return STATUS[s] ? s : 'none'
    },
    label() {
      return STATUS[this.normalizedStatus].label
    },
    variant() {
      return STATUS[this.normalizedStatus].variant
    },
  },
}
</script>
